export enum Field {
  INPUT = 'INPUT',
  OUTPUT = 'OUTPUT',
}
